import { cloneElement, isValidElement, useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SocialButton from "../SocialButton";
import Logo from '../../assets/mic_logo.png'
import { topRights } from '../../jsons/topRights'
import { topLefts } from "../../jsons/topLefts";
import { session, clearSession, setSession, auth } from '../../utils/AuthSession'
import { gapi } from 'gapi-script';
import { GoogleLogin, GoogleLogout } from 'react-google-login'
import { AiOutlineLeft } from "react-icons/ai";
import { FaWhatsapp } from 'react-icons/fa'
import { ThemeContext } from "../../context/ThemeContext";
import { StoreContext } from '../../context/StoreContext'
import { clearProductCatalogContext } from '../../utils/productCatalogContext'

const normalizeWhatsappNumber = (value) => {
    const digits = `${value || ''}`.replace(/\D/g, '')
    if (!digits) return ''
    if (digits.startsWith('0')) return `62${digits.slice(1)}`
    if (digits.startsWith('8')) return `62${digits}`
    return digits
}

const Navbar = ({ showLogin = false }) => {
    const {primaryColor, primaryColorHover, partnerLogo} = useContext(ThemeContext)
    const { activeStore } = useContext(StoreContext) || {}
    const navbarColor = primaryColor || process.env.REACT_APP_DEFAULT_PRIMARY_COLOR || '#2563eb'
    const navigate = useNavigate()
    const location = useLocation()
    const [isPartnerLogoFailed, setIsPartnerLogoFailed] = useState(false)
    const isProductDetailRoute = /^\/product\/[^/]+/.test(location.pathname)
    const isCartRoute = location.pathname.startsWith('/cart')
    const isTransactionListRoute = location.pathname.startsWith('/transaction/list')
    const isFinalPaymentStatusRoute = ['/order/status/success', '/order/status/error'].includes(location.pathname)
    const useCompactCartHeader = isCartRoute && !showLogin
    const useCompactTransactionHeader = isTransactionListRoute && !showLogin
    // Ukuran navigasi atas mengikuti acuan halaman produk di seluruh halaman.
    const topNavLabelClassName = 'text-[10px] leading-none'
    const topNavIconClassName = 'text-[21px] leading-none'
    const contactWhatsappNumber = normalizeWhatsappNumber(
        activeStore?.store_whatsapp || activeStore?.whatsapp || activeStore?.store_phone || activeStore?.phone
    )

    useEffect(() => {
        setIsPartnerLogoFailed(false)
    }, [partnerLogo])

    const renderTopNavIcon = (nav) => {
        if (nav.title === 'Product' && partnerLogo && !isPartnerLogoFailed) {
            return (
                <img
                    src={partnerLogo}
                    alt="Logo partner"
                    className="h-12 w-12 object-contain brightness-0 invert"
                    onError={() => setIsPartnerLogoFailed(true)}
                />
            )
        }

        const icon = nav.icon
        if (!isValidElement(icon)) return icon
        const existingClassName = icon.props?.className || ''

        return cloneElement(icon, {
            className: `${existingClassName} ${topNavIconClassName}`.trim(),
        })
    }

    const handleOnSuccess = () => {
        window.location.reload(false);
    }

    const handleLogout = () => {
        clearSession()
        setSession(session)
        window.location.reload(false);
    }

    const handleBack = () => {
        if (isFinalPaymentStatusRoute) {
            navigate('/transaction/list', { replace: true })
            return
        }

        if (isProductDetailRoute) {
            if (location.state?.productCatalogContext) {
                navigate(-1)
            } else {
                clearProductCatalogContext()
                navigate('/product', { replace: true })
            }
            return
        }

        navigate(-1)
    }

    const handleContactUs = () => {
        if (!contactWhatsappNumber) return
        window.open(`https://wa.me/${contactWhatsappNumber}`, '_blank', 'noopener,noreferrer')
    }

    useEffect(() => {
        if (isProductDetailRoute && !location.state?.productCatalogContext) {
            clearProductCatalogContext()
        }
    }, [isProductDetailRoute, location.state])


    return (
        <div className="fixed top-0 left-1/2 z-50 h-16 w-full -translate-x-1/2 md:max-w-2xl" style={{backgroundColor: navbarColor}}>
            <div className={`h-full w-full ${useCompactCartHeader ? 'grid grid-cols-[56px_1fr_56px] items-center' : 'flex justify-between'} ${useCompactTransactionHeader ? 'relative' : ''}`}>
                <div className={useCompactCartHeader ? 'flex items-center justify-start' : 'flex'}>
                    <div className="flex grid-cols-1">
                        <button
                            type="button"
                            aria-label="Kembali"
                            className="inline-flex flex-col items-center justify-center px-3 text-white"
                            onClick={handleBack}
                        >
                            <AiOutlineLeft className="text-2xl" />
                        </button>
                        {showLogin && partnerLogo && !isPartnerLogoFailed && (
                            <button
                                type="button"
                                aria-label="Halaman produk"
                                className="inline-flex flex-col items-center justify-center px-1 text-white"
                                onClick={() => navigate('/product')}
                            >
                                <img
                                    src={partnerLogo}
                                    alt="Logo partner"
                                    className="h-12 w-12 object-contain brightness-0 invert"
                                    onError={() => setIsPartnerLogoFailed(true)}
                                />
                            </button>
                        )}
                    </div>
                    {!showLogin && !useCompactCartHeader && !useCompactTransactionHeader && (
                        <div className="flex h-full grid-cols-6">
                            {topLefts.map((nav, i) => (
                                <button key={i} type="button" className="inline-flex min-w-0 flex-col items-center justify-center px-2 text-white hover:opacity-50 group"
                                    onClick={() => navigate(nav.link)}
                                >
                                    {renderTopNavIcon(nav)}
                                    {nav.title !== 'Product' && <span className={topNavLabelClassName}>{nav.title}</span>}
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                {useCompactCartHeader && (
                    <div className="flex items-center justify-center text-white">
                        <h1 className="text-base font-semibold tracking-wide">Keranjang Belanja</h1>
                    </div>
                )}

                {useCompactTransactionHeader && (
                    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                        <h1 className="text-base font-semibold tracking-wide text-white">Riwayat Transaksi</h1>
                    </div>
                )}

                <div className={useCompactCartHeader ? 'flex items-center justify-end' : 'flex h-full grid-cols-6'}>
                    {showLogin && (
                        <button
                            type="button"
                            className="inline-flex self-center h-9 items-center justify-center px-4 text-sm font-semibold text-white bg-black/20 rounded-lg mr-2"
                            onClick={() => navigate('/auth/login')}
                        >
                            Login
                        </button>
                    )}
                    {!showLogin && !useCompactCartHeader && topRights.map((nav, i) => (
                        <button key={i} type="button" className="inline-flex min-w-0 flex-col items-center justify-center px-2 text-white hover:opacity-50 group"
                            onClick={() => navigate(nav.link)}
                        >
                            {renderTopNavIcon(nav)}
                            <span className={topNavLabelClassName}>{nav.title}</span>
                        </button>
                    ))}
                    {!showLogin && !useCompactCartHeader && (
                        <button
                            type="button"
                            aria-label="Hubungi kami melalui WhatsApp"
                            title={contactWhatsappNumber ? 'Hubungi Kami' : 'Nomor WhatsApp toko belum tersedia'}
                            disabled={!contactWhatsappNumber}
                            className="inline-flex min-w-0 flex-col items-center justify-center px-2 text-white hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50"
                            onClick={handleContactUs}
                        >
                            <FaWhatsapp className={`${topNavIconClassName} text-[#25D366]`} />
                            <span className={topNavLabelClassName}>Hubungi Kami</span>
                        </button>
                    )}
                    {useCompactCartHeader && <div className="w-12" />}
                </div>
            </div>

        </div>
    )
}

export default Navbar
